/* Livia Azzurro — Cal.com embed, loaded on first booking CTA click (saves ~80KB+ on initial load) */
(function () {
  if (typeof window === "undefined") return;

  var bootstrapped = false;
  var bootstrapping = false;
  var pendingEl = null;

  function runCalLoader() {
    (function (C, A, L) {
      var p = function (a, ar) { a.q.push(ar); };
      var d = C.document;
      C.Cal = C.Cal || function () {
        var cal = C.Cal;
        var ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          d.head.appendChild(d.createElement("script")).src = A;
          cal.loaded = true;
        }
        if (ar[0] === L) {
          var api = function () { p(api, arguments); };
          var namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === "string") {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ["initNamespace", namespace]);
          } else {
            p(cal, ar);
          }
          return;
        }
        p(cal, ar);
      };
    })(window, "https://app.cal.eu/embed/embed.js", "init");

    Cal("init", "spotkanie-w-showroomie", { origin: "https://app.cal.eu" });
    Cal.ns["spotkanie-w-showroomie"]("ui", {
      cssVarsPerTheme: {
        light: { "cal-brand": "#23212c" },
        dark: { "cal-brand": "#fbfaf6" }
      },
      hideEventTypeDetails: false,
      layout: "month_view"
    });
  }

  function flushPending() {
    if (!pendingEl) return;
    var el = pendingEl;
    pendingEl = null;
    el.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true }));
  }

  function bootstrap(el) {
    pendingEl = el;
    if (bootstrapped) {
      flushPending();
      return;
    }
    if (bootstrapping) return;
    bootstrapping = true;
    runCalLoader();

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (window.Cal && window.Cal.loaded) {
        clearInterval(timer);
        bootstrapped = true;
        bootstrapping = false;
        flushPending();
      } else if (attempts > 120) {
        clearInterval(timer);
        bootstrapping = false;
      }
    }, 50);
  }

  document.addEventListener("click", function (e) {
    var el = e.target && e.target.closest ? e.target.closest("[data-cal-link]") : null;
    if (!el) return;
    if (!bootstrapped) {
      e.preventDefault();
      bootstrap(el);
    }
  }, true);
})();
